"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotNull = exports.isNull = exports.isNotSymbol = exports.isSymbol = exports.isNotString = exports.isString = exports.isNotNumber = exports.isNumber = exports.isNotBoolean = exports.isBoolean = exports.isNotUndefined = exports.isUndefined = void 0;
var isUndefined = function (value) {
    return typeof value === 'undefined';
};
exports.isUndefined = isUndefined;
var isNotUndefined = function (value) {
    return typeof value !== 'undefined';
};
exports.isNotUndefined = isNotUndefined;
var isBoolean = function (value) {
    return typeof value === 'boolean';
};
exports.isBoolean = isBoolean;
var isNotBoolean = function (value) {
    return typeof value !== 'boolean';
};
exports.isNotBoolean = isNotBoolean;
var isNumber = function (value) {
    return typeof value === 'number';
};
exports.isNumber = isNumber;
var isNotNumber = function (value) {
    return typeof value !== 'number';
};
exports.isNotNumber = isNotNumber;
var isString = function (value) {
    return typeof value === 'string';
};
exports.isString = isString;
var isNotString = function (value) {
    return typeof value !== 'string';
};
exports.isNotString = isNotString;
var isSymbol = function (value) {
    return typeof value === 'symbol';
};
exports.isSymbol = isSymbol;
var isNotSymbol = function (value) {
    return typeof value !== 'symbol';
};
exports.isNotSymbol = isNotSymbol;
var isNull = function (value) { return value === null; };
exports.isNull = isNull;
var isNotNull = function (value) { return value !== null; };
exports.isNotNull = isNotNull;
